import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import type { SystemStyleObject, Theme } from "@mui/system";

export const rotationDirectionIconSx: SystemStyleObject<Theme> = {
  fontSize: 18,
  transform: "scale(0.88)",
};

export const StyledWrapper = styled(Box)({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
});

export const StyledChartWithLegendContainer = styled(Box)({
  display: "flex",
  width: "100%",
  height: "100%",
  minHeight: 0,
  flex: 1,
  gap: "16px",
  overflow: "hidden",
});

export const StyledChartContainer = styled(Box)({
  flex: "1 1 0%",
  minHeight: 0,
  minWidth: "200px",
  height: "100%",
  overflow: "hidden",
  position: "relative",
  contain: "size layout",
});

export const StyledLegendRightContainer = styled(Box)({
  flex: "0 0 35%",
  maxHeight: "100%",
  minHeight: 0,
  width: "35%",
  overflowY: "auto",
  overflowX: "hidden",
});

export const StyledLegendBottomContainer = styled(Box)({
  width: "100%",
  maxHeight: "30%",
  minHeight: 0,
  overflowY: "auto",
  overflowX: "hidden",
  borderTop: "1px solid #ebebf7",
});
